import "./css/font.css";
import "./App.css";
import React, { useEffect, useState } from "react";
import { WidgetContainer } from "./modules/Chat/views/WidgetContainer";
import { SettingContextProvider } from "./context/settings";

const App = () => {
    //prod: ffc947e0-ba18-497e-82d8-525f5c6c0853 - dev: 54c6af8b-f72b-4da2-8694-33a9eae7e189 
    const chatid = "";
    const [chatbotId, setChatbotId] = useState(chatid);

    useEffect(function(){
        
        window.addEventListener("message", (e) => {
            if (e.data?.chatbotId && e.data?.chatbotId !== chatbotId)
                setChatbotId(e.data.chatbotId);
        });

        window.parent.postMessage("getBotId", "*");
    }, []);

    return chatbotId ? (
        <SettingContextProvider chatbotId={chatbotId}>
            <WidgetContainer />
        </SettingContextProvider>
    ) : '';
};

export default App;
